<div>
  <canvas id="barChart">{{ chart }}</canvas>
</div>
